import React, { useState } from 'react';
import { Modal } from 'antd';
import SelectStage from './SelectStage';
import { roomStageIdsMap } from '../../../../../../constants/room/lifeCycle';
import { useRoomListStageMutation } from '../../../../api/changeRoomListStages';
import { UNCHANGED_STATE } from './constants';

const ChangeStage = ({
  visible,
  onCancel,
  onSettled,
  addressIds,
  afterClose,
}) => {
  const [value, setValue] = useState(roomStageIdsMap.acceptance);

  const { isLoading, mutate } = useRoomListStageMutation({
    onSuccess: onSettled,
  });

  const handleOk = () => {
    if (value === roomStageIdsMap.acceptance) {
      onSettled(UNCHANGED_STATE);
      return;
    }

    mutate({ addressIds, stageId: value });
  };

  const _afterClose = () => {
    setValue(roomStageIdsMap.acceptance);

    if (typeof afterClose === 'function') {
      afterClose();
    }
  };

  const handleChange = (value) => {
    setValue(value);
  };

  return (
    <Modal
      title="Изменение стадии"
      visible={visible}
      maskClosable={false}
      onCancel={onCancel}
      afterClose={_afterClose}
      onOk={handleOk}
      confirmLoading={isLoading}
      centered
    >
      <SelectStage value={value} onChange={handleChange} />
    </Modal>
  );
};

export default ChangeStage;
